import * as React from "react"

import FeatureList from './c/FeatureList/FeatureList'

import * as st from './ManyMore.styled.js'

const ManyMore = () => (
  <st.Wrap>
    <st.Content>
      <st.Title>And many more...</st.Title>
      <FeatureList />
    </st.Content>
  </st.Wrap>
)

export default ManyMore
